import { z } from 'zod';

import { WebhookEvents } from './webhook';
import { makeEndpoint, paginateResponseSchema } from '../common';

export enum WebhookEventHistoryStatus {
  SUCCESS = 'success',
  FAILED = 'failed',
}

export enum WebhookEventStatus {
  PENDING = 'pending',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export const PaginatedWebhookEventHistoryQueryRequestSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  status: z.nativeEnum(WebhookEventHistoryStatus).optional(),
});

export const PaginatedWebhookEventHistoryResponseSchema = paginateResponseSchema(
  z.object({
    id: z.string(),
    event: z.nativeEnum(WebhookEvents),
    status: z.nativeEnum(WebhookEventHistoryStatus),
    createdAt: z.string().datetime(),
  }),
);
export type PaginatedWebhookEventHistoryResponse = z.infer<typeof PaginatedWebhookEventHistoryResponseSchema>;

export const WebhookEventHistoryDetailResponseSchema = z.object({
  id: z.string(),
  url: z.string().url(),
  status: z.nativeEnum(WebhookEventHistoryStatus),
  response: z.record(z.string(), z.unknown()),
  webhookEventId: z.string().uuid(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  webhookEvent: z.object({
    id: z.string().uuid(),
    event: z.nativeEnum(WebhookEvents),
    payload: z.record(z.string(), z.unknown()),
    status: z.nativeEnum(WebhookEventStatus),
    retryCount: z.number(),
    webhookId: z.string().uuid(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
  }),
});
export type WebhookEventHistoryDetailResponse = z.infer<typeof WebhookEventHistoryDetailResponseSchema>;

export const GetPaginatedWebhookEventHistoryEndpoint = makeEndpoint({
  method: 'GET',
  url: ({ entityType, entityId, webhookId }: { entityType: string; entityId: string; webhookId: string }) =>
    `v1/${entityType}/${entityId}/webhooks/${webhookId}/webhook-event-history`,
  responseSchema: PaginatedWebhookEventHistoryResponseSchema,
  requestSchema: PaginatedWebhookEventHistoryQueryRequestSchema,
});

export const FindWebhookEventHistoryDetailEndpoint = makeEndpoint({
  method: 'GET',
  url: ({
    entityType,
    entityId,
    webhookId,
    webhookEventHistoryId,
  }: {
    entityType: string;
    entityId: string;
    webhookId: string;
    webhookEventHistoryId: string;
  }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}/webhook-event-history/${webhookEventHistoryId}`,
  responseSchema: WebhookEventHistoryDetailResponseSchema,
  requestSchema: z.void(),
});
